export default __webpack_public_path__ + "static/media/AdStorm_06.c3351b13.png";